module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"text":"Øv deg på single-systemet og vis at du behersker kodene i spillene.<br><br>OBS: Ved å bruke kloneteknikken kan du bruke de samme kodene og spille flere ganger."},"en":{"text":"Øv deg på single-systemet og vis at du behersker kodene i spillene.<br><br>OBS: Ved å bruke kloneteknikken kan du bruke de samme kodene og spille flere ganger."}}')
  delete Component.options._Ctor
}
